module.exports = __webpack_public_path__ + "static/media/hand-holding-seedling.67fdec3f.svg";